import { Form, type InputProps } from "antd";
import { useIntl } from "react-intl";
import { FormInput } from "~components/Form/FormInput";
import { FormSection } from "~components/Form/FormSection";
import { createNumberOnChange } from "~utilities/createNumberOnChange";
import parentStyles from "../../AddPersonModal.module.css";
import { addPersonFieldHelpers } from "../../constants/addPersonFieldHelpers";
import type { AddPersonForm } from "../../types/AddPersonForm";

type Props = {
  disabled?: boolean;
};

export const AdditionalDetailsSection = ({ disabled }: Props) => {
  const { formatMessage } = useIntl();
  const { additionalDetailsFields } = addPersonFieldHelpers;

  const form = Form.useFormInstance<AddPersonForm>();

  const getSharedInputNumberProps = (name: "height" | "weight"): InputProps => ({
    disabled,
    inputMode: "numeric",
    onChange: createNumberOnChange(
      (value) => {
        const additionalDetails = form.getFieldValue("additionalDetails") || {};
        form.setFieldsValue({
          additionalDetails: {
            ...additionalDetails,
            [name]: value,
          },
        });
      },
      { allowDecimal: true },
    ),
  });

  return (
    <>
      <FormSection title={formatMessage({ id: "additional.details" })} fields={additionalDetailsFields} />
      <div className={parentStyles.columnsContainer}>
        <FormInput<AddPersonForm>
          name={["additionalDetails", "height"]}
          label={formatMessage({ id: "height" })}
          inputProps={getSharedInputNumberProps("height")}
        />
        <FormInput<AddPersonForm>
          name={["additionalDetails", "weight"]}
          label={formatMessage({ id: "weight" })}
          inputProps={getSharedInputNumberProps("weight")}
        />
        <FormInput<AddPersonForm>
          name={["additionalDetails", "representation"]}
          label={formatMessage({ id: "representing" })}
          disabled={disabled}
        />
      </div>
    </>
  );
};
